export interface InstantPointerPosition {
  x: number;
  y: number;
}

export function shouldAdvanceInstant(
  start: InstantPointerPosition,
  end: InstantPointerPosition,
): boolean {
  const dx = end.x - start.x;
  const dy = end.y - start.y;
  const isTap = Math.abs(dx) <= 12 && Math.abs(dy) <= 12;

  return isTap || dy < -55 || Math.abs(dx) > 55;
}
